import backendApiClient from "./backendApiClient";
import { extractCountriesWithUserCountry } from "../extractors/countriesExtractor";

/* istanbul ignore next */
export async function loadAllowedCountries() {
  return extractCountriesWithUserCountry(
    // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
    await backendApiClient().get("/countries", {
      all: false,
      // @ts-expect-error TS(7017) FIXME: Element implicitly has an 'any' type because type ... Remove this comment to see the full error message
      language: global.configuration.language,
    }),
  );
}
